import { render } from "./JoinPinGroupView.vue?vue&type=template&id=5930f8e8&scoped=true"
import script from "./JoinPinGroupView.vue?vue&type=script&lang=js"
export * from "./JoinPinGroupView.vue?vue&type=script&lang=js"

import "./JoinPinGroupView.vue?vue&type=style&index=0&id=5930f8e8&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5930f8e8"]])

export default __exports__